import { Component, OnInit } from '@angular/core';
import { ConnectionService } from 'ngx-connection-service';
import { AuthService } from 'src/app/services/auth.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styles: [],
})
export class HeaderComponent implements OnInit {
    constructor(private authService: AuthService, public sharedService: SharedService, private connectionService: ConnectionService) {
        this.connectionService.monitor().subscribe((currentState) => {
            this.hasNetworkConnection = currentState.hasNetworkConnection;
            this.hasInternetAccess = currentState.hasInternetAccess;
            if (this.hasNetworkConnection && this.hasInternetAccess) {
                this.status = 'ONLINE';
            } else {
                this.status = 'OFFLINE';
            }
        });
    }

    hasNetworkConnection: boolean;

    hasInternetAccess: boolean;

    status: string;

    ngOnInit(): void {}

    logout() {
        this.authService.logout();
        this.authService.redirectLogoutUser();
    }

    toggleSideBar() {
        this.sharedService.sidebarOpen = !this.sharedService.sidebarOpen;
        this.sharedService.setState();
    }

    get userName(): string {
        return this.authService.currentUser ? this.authService.currentUser.userName : '';
    }
}
